import { VideogularComponent } from 'vbrick-player-src/videogular/Videogular.Component';

import { HlsPlayer } from './HlsPlayer';
import { IRevConnectInfo } from '@vbrick/vbrick-rev-connect/src/IRevConnectInfo';
import { HlsConfig } from 'hls.js';

export class HlsPeerPlayer extends HlsPlayer {
	constructor(
		src: string,
		videoElement: HTMLVideoElement,
		API: VideogularComponent,
		isLive: boolean,
		hlsJsConfigOverrides: Partial<HlsConfig>,
		isStartPrefetch?: boolean,
		revConnectInfo?: IRevConnectInfo
	) {
		super(src, videoElement, API, isLive, hlsJsConfigOverrides, isStartPrefetch, revConnectInfo);
	}

	protected initHlsJsPlayer(): Promise<void> {
		if (this.isLive && this.revConnectInfo && !this.revConnectInfo.avoidImportFactoryModule) {
			return import(/* webpackChunkName: "vbrick-rev-connect" */ '@vbrick/vbrick-rev-connect/dist/vbrick-rev-connect')
				.then(exports => {
					this.hlsJsConfigOverrides.fLoader = (window as any).vbRevConnect.revConnectForVbrickWrapper(
						this.Hls.DefaultConfig.loader,
						this.revConnectInfo,
						reason => {
							const errorEvent: Event & { details?: any } = this.createEvent('hlsNonRecoverableError');
							errorEvent.details = reason;

							this.API.onVideoError(errorEvent);
						}
					) as any;
				})
				.then(() => super.initHlsJsPlayer());
		}

		return super.initHlsJsPlayer();
	}

	public destroy(): void {
		const { fLoader } = this.hlsJsConfigOverrides as any;

		if (fLoader && fLoader.destroy) {
			fLoader.destroy();
		}

		super.destroy();
	}
}
